// extracted by mini-css-extract-plugin
export default {"transitionGroupWrapper":"a","transitionGroup":"b"};